define("shared/utils/object-methods/object-snake-to-camel", ["exports", "later/utils/object-methods", "shared/utils/string-formatters/snake-to-camel"], function (_exports, _objectMethods, _snakeToCamel) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"later/utils/object-methods",0,"shared/utils/string-formatters/snake-to-camel"eaimeta@70e063a35619d71f

  /**
   * Calls snakeToCamel on all keys in given object
   *
   * @method objectSnakeToCamel
   * @param {Object} obj Object to conxvert key names to camel case
   *
   * @return {Object} Object with camel case key names
   */
  const objectSnakeToCamel = obj => (0, _objectMethods.objectMap)(obj, _ref => {
    let [snakeCaseKey, value] = _ref;
    return [(0, _snakeToCamel.default)(snakeCaseKey), value];
  });

  var _default = objectSnakeToCamel;
  _exports.default = _default;
});